export interface IContactUsData {
  email: string;
  name: string;
}

const SubjectTypes = {
  1: 'Update MyBCMEA Info',
  2: 'Reset MyBCMEA Password',
  3: 'Sign Up MyBCMEA Account',
  4: 'MyBCMEA Inquiry',
  5: 'Payroll Inquiry',
  6: 'Training Inquiry',
  7: 'General Feedback'
}

export const CONTACT_US_FORM_TYPES = Object.entries(SubjectTypes).map(
  ([TypeId, TypeLabel]) => ({ subjectTypeId: TypeId, subjectTypeLabel: TypeLabel })
);